import client, { TokenStore } from './client';

const auth = {
  login: async (email, password) => {
    const data = await client.post('/auth/login/', { email, password });
    TokenStore.set(data.access, data.refresh);
    return data;
  },

  logout: async () => {
    const refresh = TokenStore.getRefresh();
    if (refresh) {
      await client.post('/auth/logout/', { refresh }).catch(() => {});
    }
    TokenStore.clear();
  },

  me: () => client.get('/auth/me/'),
};

export default auth;
